import React from "react";
// Zustand
import { useStore } from "../../zustand";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
// Core Components
import ViewSpaceBtn from '../ButtonsUI/ViewSpaceBtn';
import BtnLaunchAR from '../ButtonsUI/BtnLaunchAR';
import CartBtn from '../ButtonsUI/CartBtn';
// Styles
import { makeStyles } from '@material-ui/core/styles';
import { billboardStyles } from "../../assets/jss/billboardStyles";
import { withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

const useStyles = makeStyles(billboardStyles);

const Accordion = withStyles({
  root: {
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: 'rgba(0, 0, 0, .03)',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
        '& p': {
            fontWeight: 500,
            fontSize: '1.1rem',
            letterSpacing: '.025em'
        },
        '& span': {
            fontWeight: 400
        },
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(MuiAccordionSummary);


export default function VariantSwitchSideBar() {
    const [state, setState] = React.useState({ ready: false });
    const { vList } = useStore.getState().variants_payload;
    const variant_id = useStore.getState().variant_id;
    const { intent } = useStore.getState().hrx;
    const actions = useStore(state => state.actions);
    const { addToCartBtn } = useStore.getState().settings;
    const model_options = useStore.getState().model_options;
    // const dynamic_text_settings = useStore.getState().dynamic_text_settings;
    const { dynamic_text_settings } = useStore.getState().store_settings;
    const classes = useStyles(dynamic_text_settings);

    const setOptionsFields = React.useCallback(() => {
        let current_options = {}
        
        vList[variant_id].options.forEach(option => {
            current_options[option[0]] = option[1]
        })

        setState(state => ({
            ready: true,
            current_options: {...current_options},
            expanded: String(Object.keys(current_options)[0])
        }));
        // eslint-disable-next-line
    }, []);
 
    React.useEffect(() => {
        if(model_options) {
            // console.log('model_options', model_options)
            setOptionsFields();
        }
    }, [model_options, setOptionsFields]);

    const _handleOptionSelect = (changed_value, target_name) => {
        let new_variant_id;
        let new_config_options = {
            ...state.current_options,
            [target_name]: changed_value
        }
        // console.log('new_config_options', new_config_options)
        function allAreTrue(arr) {
            return arr.every(element => element === true);
        }
        
        Object.keys(vList).forEach(function(var_id, index) {
            let options_check_array = new Array(vList[var_id].options.length).fill(false);

            Object.keys(new_config_options).forEach((current_option, sub_index) => {
                // if option names do not equal each other
                // console.log("current_option", current_option)
                // console.log('vList[var_id].options[sub_index][0]', vList[var_id].options[sub_index][0])
                if(current_option !== vList[var_id].options[sub_index][0]) return;
                // check if option values match
                // console.log("new_config_options[current_option]", new_config_options[current_option])
                // console.log('vList[var_id].options[sub_index][1]', vList[var_id].options[sub_index][1])
                if(new_config_options[current_option] !== vList[var_id].options[sub_index][1]) return;

                options_check_array[sub_index] = true
            })
            // console.log('options_check_array', options_check_array)
            // options_check_array needs to equal to pass [true, true, true]
            if(allAreTrue(options_check_array)) {
                new_variant_id = var_id
                return
            }
        })

        setState(state => ({
            ...state,
            current_options: {
                ...new_config_options
            }
        }));

        actions.setVariant(new_variant_id)
    }

    const _handleSwatch = (texture, status) => {
        if(texture === null) {
            return (
                <svg className={clsx({ [classes.swatch_active] : status })} viewBox="0 0 90 90" width="90px" height="90px">
                    <rect width="90" height="90" x="0" y="0" fill={"#ffffff"} />
                </svg>
            )            
        } else if(texture.startsWith("#")) {
            return (
                <svg className={clsx({ [classes.swatch_active] : status })} viewBox="0 0 90 90" width="90px" height="90px">
                    <rect width="90" height="90" x="0" y="0" fill={texture} />
                </svg>
            )
        } else if(texture.startsWith("https")) {
            return <img src={texture} alt="swatch" className={clsx({[classes.image_swatch] : true, [classes.swatch_active] : status })} />
        }
    }

    const handleChange = (panel) => (event, newExpanded) => {
        setState(state => ({
            ...state,
            expanded: newExpanded ? panel : false
        }));
    };

    if(!state.ready) return null
    
    return (
        <div className={classes.billboard_sidebar}>
            <h1 className={classes.variant_title}>{vList[variant_id].title}</h1>
            <span className={classes.variant_price}>${vList[variant_id].price}</span>
            <div className={classes.billboard_icon}>
                <div className={classes.billboard_icon_content}>
                { ((intent === 'willQL') || (intent === 'canQL') || (intent === 'willSV') || (intent === 'canSV')) &&
                    <BtnLaunchAR design="rotate_icon" />
                }
                { ((intent === 'willDQL') || (intent === 'willDSV') || (intent === 'wontDQL') || (intent === "cant")) &&
                    <ViewSpaceBtn design="rotate_icon" /> 
                }
                </div>
            </div>
            <div className={classes.variant_options}>
            { Object.keys(model_options).map((option, index) => {
                let name = model_options[option].name;
                let current_name_value = state.current_options[model_options[option].name];

                return (
                    <Accordion key={index} square expanded={state.expanded === model_options[option].name} onChange={handleChange(model_options[option].name)}>
                        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={<ExpandMoreIcon />}>
                            <Typography>{model_options[option].name}: <span>{current_name_value}</span></Typography>
                        </AccordionSummary>
                        <MuiAccordionDetails style={{ padding: 10 }}>
                        { name === 'Color' ? (
                        <div className={classes.color_container}>
                        { model_options[option].values.map((value, index) => {
                            return (
                                <div className={clsx({
                                        [classes.option_value] : true,
                                        [classes.option_swatch] : true,
                                        [classes.active_option] : value.label === current_name_value
                                    })}
                                    key={`${index}_text`} 
                                    data-value={value.label}
                                    onClick={(e) => _handleOptionSelect(value.label, 'Color')}>
                                        {_handleSwatch(value.texture, value.label === current_name_value)}
                                        <span className={classes.swatch_label}>{value.label !== null ? value.label : null}</span>
                                </div>
                            )
                        })}
                        </div>
                        ) : (
                        <FormControl className={classes.formControl}>
                            <InputLabel id="simple-select-label">Current {name}</InputLabel>
                            <Select
                                labelId="simple-select-label"
                                id="simple-select"
                                value={state.current_options[name]}
                                onChange={(e) => _handleOptionSelect(e.target.value, name)}
                            >
                                { model_options[option].values.map((value, index) => {
                                    return (
                                        <MenuItem disableRipple disabled={value.label === current_name_value ? true : false} key={`${index}_opt`} value={value.label}>{value.label}</MenuItem>
                                    )
                                })}
                            </Select>
                        </FormControl>
                        )}
                        </MuiAccordionDetails>
                    </Accordion>
                );
            })}
            </div>

            <div className={classes.billboard_buttons}>
                {vList[variant_id].options.length < 2 &&
                    <div className={classes.image_container_focus} id="image_container_focus" style={{ backgroundImage: `url(${vList[variant_id].billboard_list[0].info.image_1.src})` }} />
                }
                <div className={classes.buttons_wrapper}>
                    { addToCartBtn && <CartBtn type="normal" /> }
                    { ((intent === 'willQL') || (intent === 'canQL') || (intent === 'willSV') || (intent === 'canSV')) &&
                        <BtnLaunchAR />
                    }
                    { ((intent === 'willDQL') || (intent === 'willDSV') || (intent === 'wontDQL') || (intent === "cant")) &&
                        <ViewSpaceBtn />
                    }
                </div>
            </div>
        </div>
    );
}